import * as tslib_1 from "tslib";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'react-tabs';
import "./PopoverTabs.css";

var PopoverTabs =
/** @class */
function (_super) {
  tslib_1.__extends(PopoverTabs, _super);

  function PopoverTabs() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PopoverTabs.prototype.componentDidMount = function () {
    if (!this.node) {
      return;
    }

    var tabs = this.node.querySelector('[role=tablist]');

    if (tabs) {
      this.node.style.minHeight = tabs.offsetWidth + "px";
    }
  };

  PopoverTabs.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        props = tslib_1.__rest(_a, ["className"]);

    return React.createElement(Tabs, tslib_1.__assign({
      domRef: function domRef(node) {
        return _this.node = node;
      },
      className: [className || '', 'nx-popover-tabs']
    }, props));
  };

  PopoverTabs.propTypes = {
    className: PropTypes.string
  };
  return PopoverTabs;
}(PureComponent);

export default PopoverTabs;

try {
  // @ts-ignore
  PopoverTabs.__docgenInfo = {
    "description": "",
    "displayName": "PopoverTabs",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}